import {
  Anchor,
  Box,
  Divider,
  Flex,
  LoadingOverlay,
  Title,
} from '@mantine/core'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { useUserVerified } from '@flecto/auth'
import { useMutationSyncUserIdentities } from '@flecto/core/shared'
import { Trans, useTranslation } from '@flecto/translations'
import { Logo, DropdownLanguageSelector } from '@flecto/ui'
import { Page } from '@flecto/ui/saas'

import { FormOnboarding } from '../components/FormOnboarding/FormOnboarding'
import { StepperVertical } from '../components/StepperVertical/StepperVertical'
import classes from './styles.module.css'

export function OnboardingPage() {
  const router = useRouter()
  const { mutateAsync: syncUserIdentities } = useMutationSyncUserIdentities()
  const { isUserOnboarded, isUserVerified, isLoading } = useUserVerified()

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isUserVerified) {
        syncUserIdentities()
      }
    }, 5000)

    return () => clearInterval(interval)
  }, [isUserVerified])

  if (isLoading) {
    return <LoadingOverlay visible />
  }

  if (isUserOnboarded && !isLoading) {
    router.push('/schedule')
  }

  if (!isUserVerified && !isLoading) {
    return <PageVerifyEmail />
  }

  return <PageOnboarding />
}

function PageOnboarding() {
  const { t } = useTranslation('saas', { keyPrefix: 'onboarding' })

  return (
    <Page withContainer>
      <Page.Content className={classes.content}>
        <Flex align='center' justify='space-between' mb='md'>
          <Logo withText style={{ width: '100px' }} />
          <DropdownLanguageSelector position='bottom-end' />
        </Flex>
        <Box>
          <Title order={2}>{t('heading_title')}</Title>
          <Title order={3} c='dimmed'>
            {t('heading_subtitle')}
          </Title>
          <Divider my='xl' />
        </Box>
        <FormOnboarding />
      </Page.Content>
      <Page.Sidebar className={classes.sidebar}>
        <StepperVertical className={classes.verticalStepper} />
      </Page.Sidebar>
    </Page>
  )
}

function PageVerifyEmail() {
  const { t } = useTranslation('saas', { keyPrefix: 'onboarding' })

  return (
    <Page withContainer>
      <Page.Content className={classes.content}>
        <Flex align='center' justify='space-between' mb='md'>
          <Logo withText style={{ width: '100px' }} />
          <DropdownLanguageSelector position='bottom-end' />
        </Flex>
        <Title order={2}>{t('heading_title_waiting')}</Title>
        <Title order={3} c='dimmed'>
          {t('heading_subtitle_waiting')}
        </Title>
        <Title order={3} c='dimmed' mt='md'>
          <Trans
            ns='saas'
            i18nKey='onboarding.heading_subtitle_waiting_more'
            components={[
              <Anchor
                key='refresh-link'
                href='javascript:void(0)'
                style={{ fontSize: 'inherit', fontWeight: 'inherit' }}
                onClick={() => {
                  window.location.reload()
                }}
              />,
            ]}
          />
        </Title>
      </Page.Content>
    </Page>
  )
}
